export default function Theory() {
  return (
    <div className="max-w-[1400px] mx-auto px-6 py-16 lg:py-24" data-testid="theory-page">
      <div className="eyebrow">Foundations</div>
      <h1 className="mt-6 font-serif text-5xl lg:text-6xl text-[#1A1915] leading-[0.95]">Theory</h1>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="eyebrow">01 · Provenance</div>
        </div>
        <div className="md:col-span-8">
          <p className="text-lg text-[#1A1915] leading-relaxed">
            The five-dimension model draws from Stoic practical philosophy, cognitive-behavioural evidence on habit repetition, and observational studies of high-signal operators. It is not psychometric. It is diagnostic.
          </p>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-[#1A1915]/15 pt-16">
        <div className="md:col-span-4">
          <div className="eyebrow">02 · Multiplicative Not Additive</div>
        </div>
        <div className="md:col-span-8">
          <p className="text-lg text-[#1A1915] leading-relaxed">
            The Effect score is not the average of your five dimensions. It is throttled by the minimum. In behavioural terms: weakness in one dimension is not compensated by strength in another. The room notices the gap.
          </p>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-[#1A1915]/15 pt-16">
        <div className="md:col-span-4">
          <div className="eyebrow">03 · Diagnosis, Not Coaching</div>
        </div>
        <div className="md:col-span-8">
          <p className="text-lg text-[#1A1915] leading-relaxed">
            The instrument produces a written diagnosis. It does not offer weekly emails, courses, or community. What you do with the verdict is your responsibility. The report is the artifact. The action plan is prescriptive but implementation is yours.
          </p>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-[#1A1915]/15 pt-16">
        <div className="md:col-span-4">
          <div className="eyebrow">04 · What The Score Is Not</div>
        </div>
        <div className="md:col-span-8">
          <ul className="space-y-4 text-lg text-[#1A1915]">
            <li>Not a personality assessment.</li>
            <li>Not a leadership index.</li>
            <li>Not a career prediction.</li>
            <li>Not therapy, medical advice, or coaching.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
